// Local copy of appearance data that can be modified independently
export const AVAILABLE_CHARACTER_APPEARANCES = [
  {
    id: "1",
    gender: "female",
    prompt:
      "She has straight blonde hair with bangs, blue eyes, and wears multiple layered silver necklaces along with a flowy white top. Her lips are slightly pursed as she speaks, maintaining direct eye contact with the camera, conveying an expressive and engaging presence.",
  },
  {
    id: "2",
    gender: "female",
    prompt:
      "She has long, wavy dark brown hair, green eyes, and wears a beige sweater over a white top with a delicate gold necklace. Her expression is warm and engaging, with a slight smile as she looks directly at the camera while gesturing gently with her hands.",
  },
  {
    id: "3",
    gender: "female",
    prompt:
      "She has long, dark brown hair and wears a cream-colored knitted cardigan with pastel patterns over a white top, accessorized with a small gold pendant necklace. Her facial expression is playful and expressive, with slightly raised eyebrows and a subtle smirk, as she looks directly at the camera.",
  },
  {
    id: "4",
    gender: "female",
    prompt:
      "She has long, dark brown hair pulled back into a high ponytail and wears a colorful, patterned sleeveless top along with silver dangling earrings and a delicate pendant necklace. Her expression is confident and focused as she speaks into a professional Shure microphone, with her hands clasped together on the table in front of her.",
  },
  {
    id: "5",
    gender: "female",
    prompt:
      "She has long, voluminous brown hair styled in loose waves and wears a light-colored blazer along with a diamond necklace and a large ring. Her expression is assertive and focused, with slightly parted lips as she speaks while looking directly at the camera.",
  },
  {
    id: "6",
    gender: "female",
    prompt:
      "She has dark, curly hair tied up in a bun, thick eyebrows, and wears a white zip-up jacket with layered gold necklaces. Her expression is enthusiastic and engaged as she speaks directly to the camera, with bright eyes and a slight smile while wearing white earphones.",
  },
  {
    id: "7",
    gender: "female",
    prompt:
      "She has long, dark hair styled straight and wears a brown ribbed sweater along with gold hoop earrings and a nose ring. Her expression is serious and engaged as she speaks directly into a professional Shure microphone, emphasizing her words with slight facial movements.",
  },
  {
    id: "8",
    gender: "female",
    prompt:
      "She has long, wavy brown hair and wears a deep green zip-up top paired with multiple layered gold necklaces, including a star-shaped pendant. Her expression is confident and composed as she speaks into a professional Shure microphone, maintaining direct eye contact with the camera.",
  },
  {
    id: "9",
    gender: "female",
    prompt:
      "She has long, dark hair and wears a beige button-up top with a subtle texture, along with small stud earrings. Her expression is engaged and slightly inquisitive as she speaks.",
  },
  {
    id: "10",
    gender: "female",
    prompt:
      "She has long, wavy dark brown hair and wears gold hoop earrings along with layered delicate necklaces. Her expression is warm and cheerful, with a wide smile as she looks slightly upward while holding a large earthy-toned mug in her hands.",
  },
  {
    id: "11",
    gender: "female",
    prompt:
      "She has long, wavy brown hair and wears gold hoop earrings along with a cream-colored knitted sweater. Her expression is serious and engaged, with slightly pursed lips as she speaks directly to the camera.",
  },
  {
    id: "12",
    gender: "female",
    prompt:
      "She has long, dark brown hair and wears pearl drop earrings along with a casual gray t-shirt. Her expression is serious and engaged as she speaks, maintaining direct eye contact with the camera.",
  },
  {
    id: "13",
    gender: "female",
    prompt:
      "She has long, dark hair and wears round glasses, a nose ring, and a blue floral-patterned dress, accessorized with a gold ring on her right hand. Her expression is relaxed and confident as she speaks into a small, furry-covered microphone with a pink decorative pattern, looking directly at the camera.",
  },
  {
    id: "14",
    gender: "female",
    prompt:
      "She has long, straight black hair and wears a light gray zip-up hoodie, accessorized with a gold chain necklace and small earrings. Her expression is confident and assertive as she speaks while looking directly at the camera.",
  },
  {
    id: "15",
    gender: "female",
    prompt:
      "She has shoulder-length, sleek brown hair and wears a fitted teal top along with matching teal stud earrings. Her expression is confident and expressive, with slightly raised eyebrows and parted lips as she looks directly at the camera while speaking.",
  },
  {
    id: "16",
    gender: "female",
    prompt:
      "She has long, straight blonde hair and wears a black strapless top, a small square pendant necklace, and a silver nose ring. Her expression is confident and animated, with wide eyes and slightly parted lips as she gestures with her hands while looking directly at the camera.",
  },
  {
    id: "17",
    gender: "female",
    prompt:
      "She has long, golden-brown twisted braids and wears a simple gold necklace along with a fitted white top. Her expression is animated and expressive, with wide eyes and slightly raised eyebrows as she speaks.",
  },
  {
    id: "18",
    gender: "female",
    prompt:
      "She has shoulder-length, straight brown hair and wears a deep purple t-shirt layered under a plaid flannel shirt, accessorized with gold hoop earrings. Her expression is calm and confident, with a slight smile and focused eyes as she looks directly at the camera.",
  },
  {
    id: "19",
    gender: "female",
    prompt:
      "She has long, dark hair swept to one side and wears oversized tortoiseshell glasses along with silver hoop earrings and a sleeveless gray pinstriped blazer. Her expression is confident and engaging, with a bright smile as she gestures with one hand while looking directly at the camera.",
  },
  {
    id: "20",
    gender: "female",
    prompt:
      "She has long, straight blonde hair and wears a dark brown button-up sweater along with a simple gold chain necklace. Her expression is focused and serious as she speaks, looking directly at the camera while wearing a clipped-on Rode microphone.",
  },
  {
    id: "21",
    gender: "male",
    prompt:
      "He has short, wavy dark brown hair, a light beard, and wears a dark brown corduroy jacket over a black shirt. His expression is calm with a subtle smirk, and he maintains direct eye contact with the camera while standing with a relaxed posture.",
  },
  {
    id: "22",
    gender: "male",
    prompt:
      "He has a light beard and mustache, wearing a dark hoodie and a green cap, while sitting in front of a professional microphone setup. His facial expression is confident and engaging, with a slight smile as he raises one hand in an explanatory gesture, looking directly at the camera.",
  },
  {
    id: "23",
    gender: "male",
    prompt:
      "He has a light beard and mustache, wears a backward black cap, a light blue short-sleeved shirt, and has an earring in his left ear. He is speaking into a professional microphone with an engaged expression, slightly leaning forward, making direct eye contact with the camera while his right hand is clenched in a loose fist.",
  },
  {
    id: "24",
    gender: "male",
    prompt:
      "He has short, curly black hair, a neatly groomed beard, and wears a black jacket over a black sweater. He maintains steady eye contact with the camera and displays a calm, confident expression, with minimal gestures or movement. ",
  },
  {
    id: "25",
    gender: "male",
    prompt:
      "He has short, dark brown hair, wears round green-framed glasses with a slight reflection on the lenses, and is dressed in a black shirt. His facial expression is focused and engaged, with slightly pursed lips as he looks directly at the camera while speaking.",
  },
  {
    id: "26",
    gender: "male",
    prompt:
      "He has short, curly dark brown hair and wears thin, round-framed glasses along with a black t-shirt. His facial expression is serious and focused as he speaks into a professional black microphone, looking slightly past the camera.",
  },
  {
    id: "27",
    gender: "male",
    prompt:
      "He has medium-length, slightly wavy black hair and light facial stubble, wearing a loose-fitting, light gray sweatshirt. He is looking directly at the camera with a relaxed and friendly expression, slightly smiling as he speaks.",
  },
  {
    id: "28",
    gender: "male",
    prompt:
      "He has a short beard, light skin, and wears a green baseball cap, along with an orange-and-white striped sweater and dark pants. He sits in a relaxed posture with one arm resting on the chair and the other slightly raised, looking at the camera with a calm and composed expression.",
  },
  {
    id: "29",
    gender: "male",
    prompt:
      "He has wavy, light brown hair and a short beard, wearing a dark burgundy sweater while seated at a microphone. His facial expression is confident and engaged, with a slight smirk as he gestures with one hand while speaking into the professional podcasting setup.",
  },
  {
    id: "30",
    gender: "male",
    prompt:
      "He has short, wavy dark brown hair, a light beard, and wears a green shirt. His expression is warm and friendly, with a genuine smile as he looks directly at the camera, conveying an inviting and engaging presence.",
  },
  {
    id: "31",
    gender: "male",
    prompt:
      "He has short, slicked-back light brown hair and wears a beige jacket over a white t-shirt, along with a wristwatch and a wedding band on his left hand. He holds a small microphone close to his mouth with a confident and engaging expression while looking directly at the camera.",
  },
  {
    id: "32",
    gender: "male",
    prompt:
      "He has short, dark hair and wears a backward brown baseball cap along with a light gray t-shirt. His facial expression is animated and engaging, with his mouth open mid-speech and direct eye contact with the camera while holding a smartphone in his hand.",
  },
  {
    id: "33",
    gender: "male",
    prompt:
      "He has a short beard and mustache, wearing a beige baseball cap, a pearl necklace, and a bright pink cardigan over a light blue tank top. His facial expression is serious and focused as he raises one hand in a gesturing motion while looking at the camera.",
  },
  {
    id: "34",
    gender: "male",
    prompt:
      "He has a well-groomed beard, dark skin, and wears a black cap tilted slightly to the side along with a striped button-up shirt in shades of brown and red. His expression is warm and friendly, with a slight smile and direct eye contact with the camera, conveying a relaxed and inviting presence.",
  },
  {
    id: "35",
    gender: "male",
    prompt:
      "He has wavy, slightly messy dark brown hair, a mustache, and a short beard, wearing thin, round glasses and a dark-colored t-shirt. His expression is serious and focused as he speaks directly into a professional microphone, with his lips slightly pursed.",
  },
  {
    id: "36",
    gender: "male",
    prompt:
      "He has short, curly black hair, a well-groomed beard, and wears a green and maroon knitted sweater with a wide collar that exposes a tattoo on the left side of his neck. His expression is serious and engaged, with his lips slightly parted as he speaks while maintaining eye contact with the camera.",
  },
  {
    id: "37",
    gender: "male",
    prompt:
      "He has short, wavy dark brown hair and wears a dark green t-shirt with a subtle logo on the sleeve. His expression is focused and animated, with slightly pursed lips as he gestures with his right hand while looking directly at the camera.",
  },
  {
    id: "38",
    gender: "male",
    prompt:
      "He has medium-length, wavy brown hair, a well-groomed beard, and wears a white graphic t-shirt with a nose ring and visible tattoos on his hands. His expression is warm and engaging, with a smile as he gestures with one hand while holding a small microphone close to his mouth.",
  },
  {
    id: "39",
    gender: "male",
    prompt:
      "He has a lean build, wears a beige cowboy hat, dark sunglasses, and an open brown button-up shirt revealing multiple gold necklaces. His expression is calm and composed as he sits in a modern outdoor chair with his hands clasped together in a relaxed yet intentional posture, looking toward the camera.",
  },
  {
    id: "40",
    gender: "male",
    prompt:
      "He has short, curly dark brown hair, a light beard, and wears thin, round-framed glasses along with a white oversized hoodie. His expression is engaged and thoughtful as he speaks directly to the camera, with his lips slightly parted mid-sentence.",
  },
];

export const AVAILABLE_BACKGROUND_APPEARANCES = [
  {
    id: "1",
    prompt:
      "The background is colorful and lively, featuring a red and orange decorative ceiling, a bulletin board with pinned notes and images, and a vintage-style poster of a man in white holding a drink. The shot is a medium close-up, framed at eye level, with warm ambient lighting that highlights the face while the background elements add depth and character to the setting.",
  },
  {
    id: "2",
    prompt:
      "The background is a cozy, dimly lit workspace featuring a corkboard filled with pinned notes and memorabilia, a wooden shelving unit with various objects, and a warm orange-toned ambient light. The shot is a medium close-up, framed at eye level, with a mix of warm and cool lighting that highlights the face while maintaining a slightly moody and atmospheric setting.",
  },
  {
    id: "3",
    prompt:
      "The background is dimly lit with a dark, textured wall, a soft blue light on the left, and two warm glowing lights on the right, creating a moody and atmospheric setting. The shot is a medium close-up at eye level, with cinematic lighting that casts gentle shadows on the face, emphasizing depth and contrast.",
  },
  {
    id: "4",
    prompt:
      "The background is softly blurred, featuring a dimly lit workspace with a computer monitor and a large window letting in natural light, creating a balanced contrast between warm and cool tones. The shot is a close-up at eye level, with moody, well-controlled lighting that emphasizes the face while keeping the background softly out of focus.",
  },
  {
    id: "5",
    prompt:
      "The background features a stylishly decorated wall with framed artwork, vintage posters, hanging caps, and a mix of modern and retro decor, including a bright orange lamp on a side table. The shot is a medium close-up at eye level, with warm, soft lighting that enhances the inviting and artistic ambiance of the setting.",
  },
  {
    id: "6",
    prompt:
      "The background features a dimly lit room with wooden acoustic panels and a large, partially visible metallic sound diffuser, creating a warm and intimate atmosphere. The shot is a loose close-up, taken from a slightly low angle, with dramatic lighting that casts strong shadows on the face, emphasizing depth and contrast in the scene.",
  },
  {
    id: "7",
    prompt:
      "The background is softly blurred, featuring warm ambient lighting and a wooden bookshelf filled with books and decorative elements, creating a cozy and intimate atmosphere. The shot is a loose close-up at eye level, with soft, warm lighting that enhances facial features while maintaining a comfortable and inviting mood.",
  },
  {
    id: "8",
    prompt:
      "The background features a stylish, dimly lit setting with wooden slat paneling, warm ambient lighting, and a piano partially visible on the left, adding to the sophisticated atmosphere. The shot is a medium close-up at eye level, with soft, directional lighting that casts subtle shadows, creating depth and a professional yet warm tone.",
  },
  {
    id: "9",
    prompt:
      "The background is softly blurred, featuring a neutral-toned outdoor setting that provides a clean and minimalistic backdrop. The shot is a loose close-up taken from a slightly lower angle, with soft and natural lighting that highlights facial features while maintaining a smooth and balanced contrast.",
  },
  {
    id: "10",
    prompt:
      "The background is softly blurred, featuring a cozy indoor setting with warm lighting, wooden furniture, and a mix of greenery, creating a relaxed and intimate atmosphere. The shot is a loose close-up at eye level, with natural and diffused lighting that highlights facial features while maintaining a warm, inviting tone.",
  },
  {
    id: "11",
    prompt:
      "The background is dimly lit with a warm, moody ambiance, featuring blurred circular light sources and a hint of greenery, creating a cinematic effect. The shot is a loose close-up at eye level, with soft, directional lighting that highlights facial features while maintaining a contrast between the subject and the softly blurred background.",
  },
  {
    id: "12",
    prompt:
      "The background features a warmly lit indoor setting with a large potted plant, a framed picture on the wall, and soft ambient lighting, creating a relaxed and artistic atmosphere. The shot is a loose close-up at eye level, with golden sunlight casting strong highlights and shadows on the face, adding depth and warmth to the scene.",
  },
  {
    id: "13",
    prompt:
      "The background features a well-lit room with neatly arranged bookshelves and subtle decorative elements, creating a modern and professional setting. The shot is a loose close-up at eye level, with soft, even lighting that enhances clarity and provides a clean, polished aesthetic.",
  },
  {
    id: "14",
    prompt:
      "The background features a well-lit indoor setting with large green houseplants, framed artwork, and soft natural light filtering through a nearby window, creating a fresh and inviting atmosphere. The shot is a loose close-up at eye level, with warm, natural lighting that highlights facial features while complementing the earthy tones of the background.",
  },
  {
    id: "15",
    prompt:
      "The background is softly lit with a warm, moody ambiance, featuring blurred decorative elements, a lamp, and dark furnishings that create an intimate setting. The shot is a loose close-up at eye level, with soft, directional lighting that highlights the face while maintaining a cozy and inviting atmosphere.",
  },
  {
    id: "16",
    prompt:
      "The background is dimly lit with a warm, moody ambiance, featuring blurred decorative lamps and dark furnishings that add depth to the scene. The shot is a loose close-up at eye level, with soft, directional lighting that highlights the face and enhances the dramatic, engaging tone of the moment.",
  },
  {
    id: "17",
    prompt:
      "The background is softly blurred, featuring green palm leaves and bright natural light, suggesting an outdoor or tropical setting. The shot is a medium close-up at eye level, with well-balanced natural lighting that illuminates the face while maintaining a vibrant and engaging atmosphere.",
  },
  {
    id: "18",
    prompt:
      "The background features a cozy indoor setting with wooden beams, soft natural lighting, and a few decorative elements, creating a relaxed and inviting atmosphere. The shot is a loose close-up at eye level, with natural lighting that highlights the face and enhances the warm, personal feel of the moment.",
  },
  {
    id: "19",
    prompt:
      "The background is a cozy and aesthetically pleasing indoor space, featuring large green plants, pastel-colored wall patterns, and decorative candles, creating a warm and inviting atmosphere. The shot is a tight-medium close-up at eye level, with soft, natural lighting that highlights the features while keeping the setting vibrant and dynamic.",
  },
  {
    id: "20",
    prompt:
      "The background is softly blurred, featuring a warm-toned, indoor setting with wooden shelves and decorative elements, creating a cozy yet professional atmosphere. The shot is a tight-medium close-up at eye level, with soft, even lighting that highlights the face while maintaining a polished and engaging composition.",
  },
];

export const GREEN_SCREEN_BACKGROUND_APPEARANCE =
  "The background is a straight green screen. The green is the same consistent color of bright green.";

export function getRandomAppearance() {
  const randomIndex = Math.floor(Math.random() * AVAILABLE_CHARACTER_APPEARANCES.length);
  return AVAILABLE_CHARACTER_APPEARANCES[randomIndex].prompt;
}

export function getRandomAppearanceByGender(gender: "male" | "female") {
  const genderFilteredAppearances = AVAILABLE_CHARACTER_APPEARANCES.filter(
    (appearance) => appearance.gender === gender
  );
  const randomIndex = Math.floor(Math.random() * genderFilteredAppearances.length);
  return genderFilteredAppearances[randomIndex];
}

export function getRandomBackground() {
  const randomIndex = Math.floor(Math.random() * AVAILABLE_BACKGROUND_APPEARANCES.length);
  return AVAILABLE_BACKGROUND_APPEARANCES[randomIndex];
}
